import { parse } from "date-fns";

import type { TPickupTimeFramesResponse } from "../models/pickupTimeFrames";
import type { TPickupTimeFrame } from "../types";

const mapPickupTimeFramesResponse = (response: TPickupTimeFramesResponse): TPickupTimeFrame[] =>
  (response?.timeFrames || []).map((timeFrame) => ({
    date: parse(timeFrame.date, "yyyy-MM-dd", new Date()),
    timeFrameFrom: timeFrame.timeFramesDTO?.timeFrameFrom,
    timeFrameTo: timeFrame.timeFramesDTO?.timeFrameTo,
    minimalInterval: timeFrame.timeFramesDTO?.minimalInterval,
    cutoff: timeFrame.timeFramesDTO?.cutoff,
  }));
export default mapPickupTimeFramesResponse;
